import { PlaySquareOutlined, RobotFilled } from '@ant-design/icons-vue'
import { getComponent } from '../utils'
import { h } from 'vue'
import { prefix } from '../prefix'
import Layout from '@/layouts/main-layout.vue'
import type { RouteRecordRaw } from 'vue-router'

export const project_routes: RouteRecordRaw[] = [
  {
    path: '/project/list',
    name: 'project-list',
    component: () => getComponent(`pages/project/project-list.vue`),
    meta: {
      title: () => 'projects',
      layout: Layout,
      is_public: false,
      menu: {
        key: 'projects',
        label: 'projects',
        icon: () => h(PlaySquareOutlined),
        path: `${prefix}/project/list`,
      },
    },
  },
  {
    path: '/project/new',
    name: 'project-new',
    component: () => getComponent(`pages/project/project-new.vue`),
    meta: {
      title: () => `New project`,
      layout: Layout,
      is_public: false,
    },
  },
  {
    path: '/project/:id(\\d+)+/edit',
    name: 'project-edit',
    component: () => getComponent(`pages/project/project-edit.vue`),
    meta: {
      title: () => `Edit project`,
      layout: Layout,
      is_public: false,
    },
  },
  {
    path: '/project/:id(\\d+)+',
    name: 'project-details',
    component: () => getComponent(`pages/project/project-details.vue`),
    meta: {
      title: ({ id }: { id: string }) => `project #${id}`,
      layout: Layout,
      is_public: false,
    },
  },
]
